import { SDK_STATUSES } from "@/shared/gift-cards.constants";

import { localeCountryCodeMap } from "@/translations/config";

import {
    giftCardCheckout,
    giftCardOrderConfirmation,
} from "@/pages/api/store-directory/gift-cards";

import { APIGiftCardCheckout, GiftCardCheckout } from "@/interfaces/gift-cards/gift-card-interface";
import {
    transformOrderConfirmation,
    transformCheckout,
} from "@/interfaces/gift-cards/gift-card-transform";

import { Locale } from "@/types/locale";

export const createOrder = async (
    checkoutFields: GiftCardCheckout,
    locale: Locale
): Promise<number> => {
    const countryCode = localeCountryCodeMap[locale];
    const checkout = transformCheckout(checkoutFields);
    const checkoutResponse = await giftCardCheckout(checkout, locale);
    const { token } = checkoutResponse.data;

    return new Promise((resolve, reject) => {
        AfterPay.initialize({ countryCode });
        AfterPay.open();
        AfterPay.onComplete = async (event: { data?: { status?: string } }) => {
            if (event?.data?.status === SDK_STATUSES.CANCELLED) {
                return reject(new Error("Checkout cancelled by user"));
            }
            const { data } = await giftCardOrderConfirmation(token, checkout, locale);
            const orderConfirmation = transformOrderConfirmation(data);
            resolve(orderConfirmation.orderId);
        };
        AfterPay.transfer({ token });
    });
};

export const processOrder = async (
    token: string,
    checkoutFields: APIGiftCardCheckout,
    locale: Locale,
): Promise<number> => {
    try {
        const { data } = await giftCardOrderConfirmation(
            token,
            checkoutFields,
            locale,
        );
        const orderConfirmation = transformOrderConfirmation(data);
        return orderConfirmation.orderId;
    } catch (err) {
        throw new Error(`Failed to process order: ${err}`);
    }
};
